import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import SlotNumber from '../Inputs/SlotNumber';
import MetaId from '../Inputs/MetaId';
import FinalSlot from '../Inputs/FinalSlot';
import Pause from '../Inputs/Pause';
import useStyles from './styles';

function NewMeta({title, meta, submitForm, update}) {

  const classes = useStyles();

  const [state, setState] = useState({...meta});

  const onStateChange = event => {
    event.persist && event.persist();
    setState(prevState => ({
      ...prevState,
      [event.target.id]: event.target.value
    }));
  } ;
  useEffect(() => setState({...meta}), [meta]);

  const handleSubmit = event => {
    event.preventDefault();
    submitForm({...state});
    setState({...meta});
  };

  return (
    <form onSubmit={handleSubmit} className={classes.container}>
      <Grid container spacing={8}>
        <Grid item xs={12}>
          {title}
        </Grid>

        <Grid item xs={12} md={6}>
          <MetaId
            value={state._id}
            onChange={onStateChange}
            fullWidth
            required
            disabled={update}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SlotNumber
            value={state.slotNumber}
            onChange={onStateChange}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FinalSlot
            value={state.finalSlot}
            onChange={onStateChange}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Pause
            value={state.paused}
            onChange={onStateChange}
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            size='large'
            fullWidth
            className={classes.margin}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

NewMeta.propTypes = {
  title: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    _id: PropTypes.string,
    slotNumber: PropTypes.number,
    finalSlot: PropTypes.bool,
    paused: PropTypes.bool,
  }),
  submitForm: PropTypes.func.isRequired,
  update: PropTypes.bool.isRequired
};

NewMeta.defaultProps = {
  meta: {
    _id: '',
    slotNumber: 6,
    finalSlot: false,
    paused: false
  },
};

export default NewMeta;
